import { render } from "./PayBalance.vue?vue&type=template&id=3be14e5f&scoped=true"
import script from "./PayBalance.vue?vue&type=script&lang=js"
export * from "./PayBalance.vue?vue&type=script&lang=js"

import "./PayBalance.vue?vue&type=style&index=0&id=3be14e5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be14e5f"]])

export default __exports__